// extracted by mini-css-extract-plugin
export const Footer = "Footer-module--Footer--1IeE-";
export const SocialWrapper = "Footer-module--SocialWrapper--F2nOx";
export const SocialItems = "Footer-module--SocialItems--Z1uqC";
export const SocialLink = "Footer-module--SocialLink--3QZYq";
export const Rights = "Footer-module--Rights--xdu3k";